'use strict';

export default class TrailerCtrl {
  static get UID() {
    return 'trailerCtrl';
  }

  constructor(siteConst, $stateParams, videoFac, $sce, BASE_URLS) {
    'ngInject';

    this.config = {
      'preload': 'none',
      'plugins': {
        'controls': {
          'autoHide': true,
          'autoHideTime': 5000
        }
      }
    };

    this.advertPoints = siteConst.advert.trailer;

    videoFac.getTrailer($stateParams.updateId)
      .then((response) => {

        if( response.data.data.trailer.link !== '' ) {
          var source = {'src': $sce.trustAsResourceUrl(BASE_URLS.CONTENT + response.data.data.trailer.link), 'type': 'video/' + response.data.data.trailer.type};
          this.config.sources = [source];

          if( response.data.data.trailer.width && response.data.data.trailer.height ) {
            this.dims = { width: response.data.data.trailer.width + 'px', height: response.data.data.trailer.height + 'px' };
          }
        }
        this.video = response.data.data;
      });
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/trailer/trailerCtrl.js